import axios from "axios";
import * as actionTypes from "./actionTypes";

export const initGetPreviewPost = () => {
  return {
    type: actionTypes.INIT_GET_PREVIEW_POST,
    loadingPreview: true,
    previewPost: null,
  };
};

export const successGetPreviewPost = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_PREVIEW_POST,
    loadingPreview: false,
    previewPost: data,
  };
};

export const failGetPreviewPost = (error) => {
  return {
    type: actionTypes.FAIL_GET_PREVIEW_POST,
    loadingPreview: false,
    error: error,
  };
};

export const getPreviewPost = (postId) => {
  return (dispatch) => {
    dispatch(initGetPreviewPost());
    axios
      .get(`all/lists/${postId}`)
      .then((response) => {
        dispatch(successGetPreviewPost(response.data));
      })
      .catch((error) => {
        dispatch(failGetPreviewPost(error.message));
      });
  };
};

export const initSendPostSubmit = () => {
  return {
    type: actionTypes.INIT_SEND_POST_SUBMIT,
    submiting: true,
  };
};

export const successSendPostSubmit = (data) => {
  return {
    type: actionTypes.SUCCESS_SEND_POST_SUBMIT,
    submiting: false,
    submited: data,
  };
};

export const failSendPostSubmit = (error) => {
  return {
    type: actionTypes.FAIL_SEND_POST_SUBMIT,
    submiting: false,
    submitError: error,
  };
};

export const sendPostSubmit = (postId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };

  const data = {
    is_published: 1,
    is_reviewed: 0,
  };
  return (dispatch) => {
    dispatch(initSendPostSubmit());
    axios
      .put(`all/lists/${postId}`, data, config)
      .then((response) => {
        dispatch(successSendPostSubmit(response));
        localStorage.removeItem("draftId");
      })
      .catch((error) => {
        dispatch(failSendPostSubmit(error.message));
      });
  };
};
